var map = {
	"./de": [
		70,
		0
	],
	"./de.json": [
		70,
		0
	],
	"./en": [
		71,
		1
	],
	"./en.json": [
		71,
		1
	],
	"./es": [
		72,
		2
	],
	"./es.json": [
		72,
		2
	],
	"./fr": [
		73,
		3
	],
	"./fr.json": [
		73,
		3
	],
	"./zh": [
		74,
		4
	],
	"./zh.json": [
		74,
		4
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 63;
module.exports = webpackAsyncContext;